export default __webpack_public_path__ + "0c4aace7260f854f728a5194c1ab6d11.png";